var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09863 14.7108C9.9147 13.3479 14.0853 13.3479 17.9014 14.7108C19.0099 15.1068 19.75 16.1567 19.75 17.3338V18.6493C19.75 20.2931 18.2942 21.5554 16.667 21.3231L15.7119 21.1874C13.2498 20.8357 10.7502 20.8357 8.28809 21.1874L7.33301 21.3231C5.70576 21.5554 4.25 20.2931 4.25 18.6493V17.3338C4.25004 16.1567 4.9901 15.1068 6.09863 14.7108ZM17.3965 16.1229C13.9068 14.8766 10.0932 14.8766 6.60352 16.1229C6.09181 16.3057 5.75004 16.7905 5.75 17.3338V18.6493C5.75 19.3803 6.39744 19.9421 7.12109 19.8387L8.0752 19.702C10.6783 19.3301 13.3217 19.3301 15.9248 19.702L16.8789 19.8387C17.6026 19.9421 18.25 19.3803 18.25 18.6493V17.3338C18.25 16.7905 17.9082 16.3057 17.3965 16.1229Z",
    fill: "#181F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.64927C14.6234 2.64927 16.75 4.77592 16.75 7.39927C16.75 10.0226 14.6234 12.1493 12 12.1493C9.37665 12.1493 7.25 10.0226 7.25 7.39927C7.25 4.77592 9.37665 2.64927 12 2.64927ZM12 4.14927C10.2051 4.14927 8.75 5.60434 8.75 7.39927C8.75 9.19419 10.2051 10.6493 12 10.6493C13.7949 10.6493 15.25 9.19419 15.25 7.39927C15.25 5.60434 13.7949 4.14927 12 4.14927Z",
    fill: "#181F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b761d31a2c8c1e38d0770a4922fc9e60.svg";
export { ForwardRef as ReactComponent };